import Cookies from 'js-cookie'

const AuthMaxAttempt = 'tims_auth_max_attempt'
const AuthAttempt = 'tims_auth_attempt'
const AuthGrace = 'tims_auth_grace'
const AuthForceChgPwd = 'tims_auth_force_chg_pwd'
const TokenKey = 'tims_auth_token'
const AuthExpiresOn = 'tims_auth_expires_on'
const RefreshTokenKey = 'tims_auth_refresh_token'
const RefreshExpiresOn = 'tims_refresh_expires_on'
const AuthUserId = 'tims_auth_user_id'
const AuthCustomerId = 'tims_auth_customer_id'
const AuthBranchId = 'tims_auth_branch_id'
const AuthName = 'tims_auth_name'
const AuthEmail = 'tims_auth_email'
const AuthRoles = 'tims_auth_roles'
const AuthPermissions = 'tims_auth_permissions'

// Setters
export function setAuthMaxAttempt (authMaxAttempt) {
  return Cookies.set(AuthMaxAttempt, authMaxAttempt, { expires: 1 })
}

export function setAuthAttempt (authAttempt) {
  return Cookies.set(AuthAttempt, authAttempt, { expires: 1 })
}

export function setAuthGrace (authGrace) {
  return Cookies.set(AuthGrace, authGrace)
}

export function setAuthForceChgPwd (authForceChgPwd) {
  return Cookies.set(AuthForceChgPwd, authForceChgPwd)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function setAuthExpiresOn (authExpiresOn) {
  return Cookies.set(AuthExpiresOn, authExpiresOn)
}

export function setRefreshToken (refreshToken) {
  return Cookies.set(RefreshTokenKey, refreshToken)
}

export function setRefreshExpiresOn (refreshExpiresOn) {
  return Cookies.set(RefreshExpiresOn, refreshExpiresOn)
}

export function setAuthUserId (authUserId) {
  return Cookies.set(AuthUserId, authUserId)
}

export function setAuthCustomerId (authCustomerId) {
  return Cookies.set(AuthCustomerId, authCustomerId)
}

export function setAuthBranchId (authBranchId) {
  return Cookies.set(AuthBranchId, authBranchId)
}

export function setAuthName (authName) {
  return Cookies.set(AuthName, authName)
}

export function setAuthEmail (authEmail) {
  return Cookies.set(AuthEmail, authEmail)
}

export function setAuthRoles (authRoles) {
  return Cookies.set(AuthRoles, authRoles)
}

export function setAuthPermissions (authPermissions) {
  return Cookies.set(AuthPermissions, authPermissions)
}

// Getters
export function getAuthAttempt () {
  return Cookies.get(AuthAttempt)
}

export function getAuthMaxAttempt () {
  return Cookies.get(AuthMaxAttempt)
}

export function getAuthGrace () {
  return Cookies.get(AuthGrace)
}

export function getAuthForceChgPwd () {
  return Cookies.get(AuthForceChgPwd)
}

export function getToken () {
  return Cookies.get(TokenKey)
}

export function getAuthExpiresOn () {
  return Cookies.get(AuthExpiresOn)
}

export function getRefreshToken () {
  return Cookies.get(RefreshTokenKey)
}

export function getRefreshExpiresOn () {
  return Cookies.get(RefreshExpiresOn)
}

export function getAuthRoles () {
  if(Cookies.get(AuthRoles)) {
    return Cookies.get(AuthRoles).split(',')
  } else {
    return null
  }
}

export function getAuthPermissions () {
  if(Cookies.get(AuthPermissions)) {
    return Cookies.get(AuthPermissions).split(',')
  } else {
    return null
  }
}

// Remover
export function removeAuthAttempt () {
  return Cookies.remove(AuthAttempt)
}

export function removeAuthMaxAttempt () {
  return Cookies.remove(AuthMaxAttempt)
}

export function removeAuthGrace () {
  return Cookies.remove(AuthGrace)
}

export function removeAuthForceChgPwd () {
  return Cookies.remove(AuthForceChgPwd)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function removeAuthExpiresOn () {
  return Cookies.remove(AuthExpiresOn)
}

export function removeRefreshToken () {
  return Cookies.remove(RefreshTokenKey)
}

export function removeRefreshExpiresOn () {
  return Cookies.remove(RefreshExpiresOn)
}

export function removeAuthUserId () {
  return Cookies.remove(AuthUserId)
}

export function removeAuthCustomerId () {
  return Cookies.remove(AuthCustomerId)
}

export function removeAuthName () {
  return Cookies.remove(AuthName)
}

export function removeAuthEmail () {
  return Cookies.remove(AuthEmail)
}

export function removeAuthRoles () {
  return Cookies.remove(AuthRoles)
}

export function removeAuthPermissions () {
  return Cookies.remove(AuthPermissions)
}
